/*
 *   File : story-card.js
 *   Author : https://evoqins.com
 *   Description : story card component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React from "react";
import Icon from "../icons";

export default function StoryCard({ img, onClick }) {
  return (
    <div
      onClick={onClick}
      className="e-story-card h-100 e-cursor-pointer position-relative e-w-fit border border-1 border-white p-1 rounded-12 d-flex"
    >
      <img
        src={img}
        alt={"storyImage"}
        width={179}
        className="img-fluid rounded-12"
      />

      <div className="position-absolute" style={{ top: "9%", right: "9%" }}>
        <Icon
          icon="chevron-right"
          size={12}
          className="text-facebook-blue e-story-icon opacity-100 e-cursor-pointer"
        />
      </div>
    </div>
  );
}
